import { SalesModality } from '@/@types/Contracts';
import { useTranslation } from 'react-i18next';

export function useTranslateSalesModality() {
  const { t } = useTranslation('enums/salesModality');

  return {
    [SalesModality.COMMERCIAL_CONCESSION]: t('commercial_concession'),
    [SalesModality.END_CUSTOMER]: t('end_customer'),
  };
}
